import 'i18next';
import { IsNotEmpty, MaxLength, MinLength } from 'class-validator';

import { t } from '@app-velocity/i18n';

export class WorkspaceCreateDto {
  @IsNotEmpty({
    message: t('workspaces:validation.title_cannot_be_empty'),
  })
  @MinLength(5, {
    message: t('workspaces:validation.title_too_short', {
      minLength: 5
    }),
  })
  @MaxLength(50, {
    message: t('workspaces:validation.title_too_long', {
      maxLength: 50,
    }),
  })
  name = '';
}
